export const presentationContent = {
  title: [
    { text: 'скачайте\nпрезентацию проекта ', accent: true },
    { text: 'с рендерами, фото и&nbsp;описанием проекта', accent: false },
  ],
  subtitle: [
    { text: 'философия проекта, архитектура и&nbsp;условия ', accent: false },
    { text: '— все в одной презентации', accent: true },
  ],
  phonePlaceholder: '+7 000 000 00 00',
  phoneLabel: 'введите номер телефона',
  nameLabel: 'введите имя',
  submitLabel: 'скачать презентацию',
  consentLabel: 'я даю согласие на получение рекламных и маркетинговых коммуникаций',
  disclaimer:
    'нажимая на кнопку «Записаться на просмотр», вы подтверждаете, что принимаете условия обработки ваших персональных данных в соответствии с <a href="/privacy">Политикой обработки персональных данных</a> и даете свое Согласие на обработку персональных данных',
};
